import styled from '@emotion/styled';

export const Expander = styled('div')(() => ({
  flexGrow: 1,
}));
